export default {
  getLinks: (state) => state.links,
  getOnboarding: (state) => state.onboarding,
  getReasons: (state) => state.reasons,
};
